export default __webpack_public_path__ + "static/media/blog_3sKey.ce7a870a.png";